import { useRiskSessionManager } from '@onramp/components/RiskSessionManagerProvider';
import { useRiskifiedBeacon } from '@onramp/hooks/risk/useRiskifiedBeacon';
import { useRiskifiedEligibility } from '@onramp/hooks/risk/useRiskifiedEligibility';

export function RiskifiedBeacon() {
  const { sessionKey } = useRiskSessionManager();
  const isEligible = useRiskifiedEligibility();

  useRiskifiedBeacon({ enabled: isEligible, sessionKey });

  return null;
}
